import { CrudService } from "./crudService";
import { Format } from "../helpers/formatHelper";

export class SettingsService {

    async loadConfig() {
        const url = `${Settings.HostName}/api/czconfigs/main-settings`;
        const res = await new CrudService().httpGet(url);

        if (res == null || !res.ok) {
            console.error("Not settings defined!");
            return;
        }

        const data = res.data;
        const settings: TenantSettings = {
            Title: data.name,
            Description: data.d,
            Phone: data.p,
            Email: data.m,
            OpenHours: data.oh,
            Address: data.a,
            Facebook: data.f,
            Instagram: data.i,
            Twitter: data.t,
            ButtonsColor: data.bc,
            FooterColor: data.fc,
            FontFamily: data.ff,
            Gallery: data.g,
            FollowUsDescription: data.fu,
            CurrencySymbol: data.cs,
            DecimalSeparator: data.ds,
            TimeZone: data.tz,
            Culture: data.c,
            Mainlogo: data.logo,
            DateFormat: data.df,
            Uploads: Settings.HostName + "/" + data.u,
            RegisterOn: data.reg,
            HeaderImage: data.hi !== null && data.hi !== undefined ? Settings.HostName + "/" + data.u + "/" + data.hi : window.location.protocol + '//' + window.location.host + "/img/bredcrumb.jpg",
            HasShop: data.hasShop,
            PriceWithTaxes: data.priceWithTaxes
        };

        this.setTitle(data.name);
        window.document.documentElement.lang = (data.c || "es").split("-")[0];

        return settings;

    }

    setTitle(title: any) {
        SettingsService.tenantTitle = Format.IsNull(title) ? "" : title;
        SettingsService.applyTitle();
    }

    setPageTitle(page?: string) {
        SettingsService.pageTitle = page || "";
        SettingsService.applyTitle();
    }

    private static tenantTitle = "";
    private static pageTitle = "";

    private static applyTitle() {
        if (SettingsService.tenantTitle === "" && SettingsService.pageTitle === "") {
            return; // keep the server-injected title until we know something better
        }
        const base = SettingsService.tenantTitle || "Medkus";
        window.document.title = SettingsService.pageTitle ? `${SettingsService.pageTitle} | ${base}` : base;
    }
}

export abstract class Settings {

    static readonly Prefix = window.location.host + "_";
    static readonly HostName = Settings.GetHostName();
    static readonly MedkusHostName = Settings.GetMedkusHostName();
    
    private static GetMedkusHostName(): string {
        let host = window.location.hostname !== "localhost" ? window.location.host : "localhost:4000";
        if (window.location.hostname === "172.26.54.21") 
            host = "localhost:4000";

        const protocol = process.env.NODE_ENV === "development" ? "http" : "https";

        return protocol + '://' + host;
    }

    private static GetHostName(): string {
        let host = window.location.hostname !== "localhost" ? window.location.host : "localhost:8820";
        if (window.location.hostname === "172.26.54.21") 
            host = "localhost:8820";
        const protocol = process.env.NODE_ENV === "development" ? "http" : "https";
        if (process.env.NODE_ENV === "development") {
            const port = window.location.port;
            if (port !== "" && port !== "8820") {
                host = window.location.hostname + ":8820";
            }
        }
        //const protocol = "http";
        return protocol + '://' + host;
    }
}

declare let process: { // do not delete!
    env: {
        NODE_ENV: string;
    };
};

export interface TenantSettings {
    Title?: string,
    Description?: string,
    FollowUsDescription?: string,
    Phone?: string,
    Email?: string,
    OpenHours?: string,
    Address?: string,
    Facebook?: string,
    Instagram?: string,
    Twitter?: string,
    ButtonsColor?: string,
    FooterColor?: string;
    FontFamily?: string,
    Gallery?: any[];
    HeaderImage?: string;

    CurrencySymbol?: string,
    DecimalSeparator?: string,
    TimeZone?: string,
    Culture?: string,
    Mainlogo?: string,
    Uploads?: string,
    DateFormat?: string;
    RegisterOn?: boolean;
    HasShop?: boolean;
    PriceWithTaxes?: boolean;
}
